import React, { Component } from 'react';
import { connect } from 'react-redux';
import { NavLink } from 'react-router-dom';
import { getCurrentUser } from 'redux/actions/authActions';
import PropTypes from 'prop-types';
import defaultLogo from 'assets/img/LogoSmall.png';
import SecureImage from 'components/common/SecureImage';
class BrandedLogo extends Component {
    constructor(props) {
        super(props);
        this.state = { loading: true, logo: null };
    }

    componentDidMount() {
        if (this.props.isAuthenticated) {
            this.props.getCurrentUser();
        }
    }

    static getDerivedStateFromProps(nextProps) {
        const { profile, loading } = nextProps;
        let logo = null;
        if (profile && profile?.filterValue.length > 0) {
            logo = profile?.filterValue[0]?.logo;
        }
        return { logo, loading };
    }

    render() {
        const { loading, logo } = this.state;

        return (
            <>
                {!loading && (
                    <NavLink to={'/'}>
                        <SecureImage
                            source={logo ? `/api/uploads/${logo}` : defaultLogo}
                            width={'100%'}
                            alt="Logo"
                        />
                    </NavLink>
                )}
            </>
        );
    }
}

BrandedLogo.propTypes = {
    getCurrentUser: PropTypes.func,
    profile: PropTypes.object,
    isAuthenticated: PropTypes.bool,
    // logo: PropTypes.string,
    loading: PropTypes.bool,
};

const mapStateToProps = (state) => ({
    profile: state.auth.profile,
    isAuthenticated: state.auth.isAuthenticated,
    // logo: state.auth?.user['user-filter-values']?[0]?.filterValue?.logo,
    loading: state.auth.loading,
});

export default connect(mapStateToProps, { getCurrentUser })(BrandedLogo);
